// Some stuff is not rendered below our "small" breakpoint
export const SMALL_BREAKPOINT = 400;
